import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EGeoActions } from '../../constants/actionTypes/geo';
import { ILocation } from '../../types/location';
import { TLocationMap } from '../../types/redux/geo';

export const rememberLocation = actionGenerator<EGeoActions.REMEMBER_LOCATION, TLocationMap>(
  EGeoActions.REMEMBER_LOCATION,
);

export const getLocationsRequestStart = actionGenerator<EGeoActions.GET_LOCATIONS_REQUEST_START>(
  EGeoActions.GET_LOCATIONS_REQUEST_START,
);
export const getLocationsRequestError = actionGenerator<EGeoActions.GET_LOCATIONS_REQUEST_ERROR>(
  EGeoActions.GET_LOCATIONS_REQUEST_ERROR,
);
export const getLocationsRequestSuccess = actionGenerator<EGeoActions.GET_LOCATIONS_REQUEST_SUCCESS, ILocation[]>(
  EGeoActions.GET_LOCATIONS_REQUEST_SUCCESS,
);

export type TRememberLocationAction = ReturnType<typeof rememberLocation>;
export type TGetLocationsRequestStartAction = ReturnType<typeof getLocationsRequestStart>;
export type TGetLocationsRequestErrorAction = ReturnType<typeof getLocationsRequestError>;
export type TGetLocationsRequestSuccessAction = ReturnType<typeof getLocationsRequestSuccess>;

export type TGeoActions =
  | TRememberLocationAction
  | TGetLocationsRequestStartAction
  | TGetLocationsRequestErrorAction
  | TGetLocationsRequestSuccessAction;
